module.exports = __webpack_public_path__ + "img/girl-wow-skor.2ad03423.jpg";